import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaEnvelope, FaBars, FaTimes, FaMobile, FaDatabase, FaChevronLeft, FaChevronRight, FaPaintBrush, FaServer, FaCode, FaTrophy,  FaUsers, FaCodeBranch } from 'react-icons/fa';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { database, auth } from './firebase';
import { ref, push, set, onValue, get, child } from 'firebase/database';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import ProtectedRoute from './components/ProtectedRoute';

import logo from './images/logo/cn-logo-middle.png';

import bg1 from './images/bg1.jpg';
import bg2 from './images/bg2.jpg';
import bg3 from './images/bg3.jpg';

import susovanDasProfilePhoto from './images/members-profile/susovan-ProfilePhoto.jpg';



import TeamMembers from './TeamMembers';
import Achievements from './Achievements';
import Projects from './Projects';
import NewMemberPage from './NewMemberPage';

const AppContainer = styled.div`
  font-family: 'Inter', sans-serif;
  max-width: 100dvw;
  margin: 0 auto;
  padding: 0 0;
`;

const Navbar = styled.nav`
  background: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const NavRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  font-family: 'Poppins', sans-serif;
`;

const LogoImage = styled.img`
  height: 40px;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 35px;
    margin-right: 0rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    gap: 1rem;
  }
`;

const NavLink = styled.a`
  color: #333;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  padding: 0.5rem 1rem;
  font-family: 'Inter', sans-serif;

  &:hover {
    color: #007bff;
  }

  @media (max-width: 768px) {
    padding: 0.75rem;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const HeroSection = styled.section`
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  padding-top: 220px;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  // background-color:rgb(27, 31, 35);

  @media (max-width: 768px) {
    padding-top: 160px;
  }
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0;
  background-size: cover;
  background-position: center;
  transition: opacity 1s ease-in-out;
  width: 100%;

  &.active {
    opacity: 0.2;
  }
`;

const HeroContent = styled.div`
  max-width: 800px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 20px;
  color: #000;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 2rem;
  color: #007bff;
  margin-bottom: 30px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;



const Button = styled.a`
  display: inline-block;
  padding: 20px 40px;
  background: #007bff;
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.5rem;
  border-radius: 10px;
  transition: background 0.3s ease;
  min-width: 340px;
  box-shadow: 0 4px 100px 10px rgba(0, 70, 246, 0.3);
  &:hover {
    background:#007bff;
  }
  
  @media (max-width: 768px) {
    padding: 10px 20px;
    min-width: 200px;
    font-weight: 500;
    font-size: 1.5rem;
  }
`;

const HeroButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 60px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const ExtraButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  background: #fff;
  color: #007bff;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  border-radius: 10px;
  transition: background 0.3s ease;
  min-width: 240px;
  box-shadow: 0 4px 100px 10px rgba(3, 11, 249, 0.3);
  &:hover {
    background:rgb(221, 235, 251);
  }
  
  @media (max-width: 768px) {
    padding: 10px 20px;
    min-width: 100px;
    font-weight: 700;
    font-size: 1rem;
  }
`;

const Section = styled.section`
  padding: 50px 20px;
  max-width: 100%;
  margin: 0 auto;
  min-height: 100dvh;
  background-color: #fff;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-top: 30px;
  color: #333;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  letter-spacing: -0.01em;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// const SkillsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 30px;
//   margin-top: 50px;
// `;

// const SkillCard = styled.div`
//   background: white;
//   padding: 30px;
//   border-radius: 10px;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   text-align: center;
//   transition: transform 0.3s ease;

//   &:hover {
//     transform: translateY(-5px);
//   }
// `;

// const Footer = styled.footer`
//   background: #333;
//   color: white;
//   padding: 50px 0;
//   text-align: center;
// `;

// const SocialLinks = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 20px;
//   margin-top: 20px;
// `;

// const SocialLink = styled.a`
//   color: white;
//   font-size: 1.5rem;
//   transition: color 0.3s ease;

//   &:hover {
//     color: #007bff;
//   }
// `;

const TeamSection = styled(Section)`
  background: #f8f9fa;
  padding: 50px 100px;
  width: 100%;

  @media (max-width: 1300px) {
    padding: 50px 20px;
  }

  @media (max-width: 768px) {
    padding: 50px 20px;
  }
`;

const TeamGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TeamName = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: #333;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  text-align: center;
`;

const TeamRole = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem 0;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
`;

const TeamIcon = styled.div`
  font-size: 1.2rem;
  color: #007bff;
`;

const TeamBio = styled.p`
  color: #666;
  line-height: 1.6;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
`;

const TeamSocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: auto;
  padding-top: 1rem;
`;

const TeamSocialLink = styled.a`
  color: #333;
  font-size: 1.2rem;
  transition: color 0.3s ease;

  &:hover {
    color: #007bff;
  }
`;

const TeamCard = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(25% - 1.5rem);
  min-width: 250px;
  min-height: 500px;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    min-height: auto;
  }
`;

const ProfilePhoto = styled.div`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  overflow: hidden;
  border: 5px solid #007bff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const LeaderCard = styled(TeamCard)`
  background: linear-gradient(135deg,rgb(84, 164, 250),rgb(23, 99, 180));
  color: white;
  padding: 2.5rem;
  display: flex;
  align-items: center;
  gap: 3rem;
  width: 100%;
  margin-bottom: 2rem;
  min-height: 300px;
  flex-direction: row;

  ${TeamName}, ${TeamRole}, ${TeamBio} {
    color: white;
    text-align: left;
  }

  ${TeamName} {
    font-size: 3rem;
  }

  ${TeamIcon} {
    color: white;
  }

  ${TeamSocialLink} {
    color: white;
    &:hover {
      color: #f8f9fa;
    }
  }

  ${ProfilePhoto} {
    flex: 0 0 200px;
    margin: 0;
    width: 200px;
    height: 200px;
    min-width: 200px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 5px solid #fff;
  }

  .leader-details {
    flex: 1;
    text-align: left;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  ${TeamRole} {
    justify-content: flex-start;
  }

  ${TeamSocialLinks} {
    justify-content: flex-start;
    margin-top: auto;
    padding-top: 1rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
    min-height: 500px;
    width: 100%;
    max-width: 400px;

    ${ProfilePhoto} {
      width: 150px;
      height: 150px;
      min-width: 150px;
      max-height: 150px;
      margin: 0 auto 1.5rem;
      aspect-ratio: 1/1;
      border-radius: 50%;
      border: 5px solid #fff;
    }

    .leader-details {
      text-align: center;
    }
    ${TeamName} {
      text-align: center;
      font-size: 2.5rem;
    }
    ${TeamRole}, ${TeamBio} {
      justify-content: center;
      text-align: center;
    }

    ${TeamSocialLinks} {
      justify-content: center;
      margin-top: auto;
      padding-top: 1rem;
    }
  }
`;

const CarouselControls = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  z-index: 2;
`;

const CarouselButton = styled.button`
  background: rgba(255, 255, 255, 0.3);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  color: #333;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

const CarouselIndicators = styled.div`
  display: flex;
  gap: 0.5rem;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
`;

const Indicator = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ active }) => (active ? '#007bff' : 'rgba(255, 255, 255, 0.5)')};
  cursor: pointer;
  transition: background 0.3s ease;
`;

const HeroTitle = styled(Title)`
  font-size: 4rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const HeroSubtitle = styled(Subtitle)`
  font-size: 2.5rem;
  margin-bottom: 5rem;
  white-space: nowrap;
  text-align: center;
  font-weight: 1000;
  @media (max-width: 768px) {
    font-size: 2rem;
    white-space: wrap;
    margin-bottom: 2rem;
  }
`;

const AchievementsSection = styled.section`
  padding: 2.5rem 2rem;
  background: #f8f9fa;
`;

const AchievementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 40px auto 40px auto;
`;

const AchievementCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const AchievementIcon = styled.div`
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 1rem;
`;

const AchievementTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
`;

const AchievementDescription = styled.p`
  color: #666;
  line-height: 1.6;
  font-family: 'Inter', sans-serif;
`;

// const ProjectsSection = styled.section`
//   padding: 2rem 2rem;
//   background: white;
// `;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 40px auto 40px auto;
`;

const ProjectCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ProjectImage = styled.div`
  height: 200px;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: #007bff;
  background-size: cover;
  background-position: center;
`;

const ProjectContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const ProjectTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
`;

const ProjectDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-family: 'Inter', sans-serif;
  flex: 1;
`;

const ProjectTech = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const TechTag = styled.span`
  background: #e9ecef;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  color: #495057;
  font-family: 'Inter', sans-serif;
`;

const ProjectLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  margin-top: auto;

  &:hover {
    text-decoration: underline;
  }
`;

const ContactForm = styled.form`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 15px;
  box-shadow: 0 0px 16px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const SubmitButton = styled.button`
  background: #007bff;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-left: auto;
  display: block;

  &:hover {
    background: #0056b3;
  }
`;

// const AdminContainer = styled.div`
//   max-width: 1200px;
//   margin: 2rem auto;
//   padding: 2rem;
// `;

// const AdminTitle = styled.h2`
//   font-size: 2rem;
//   margin-bottom: 2rem;
//   color: #333;
// `;

// const ContactsTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   margin-top: 1rem;
//   background: white;
//   border-radius: 10px;
//   overflow: hidden;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
// `;

// const TableHeader = styled.th`
//   padding: 1rem;
//   text-align: left;
//   background: #f8f9fa;
//   border-bottom: 2px solid #dee2e6;
// `;

// const TableRow = styled.tr`
//   &:nth-child(even) {
//     background: #f8f9fa;
//   }
// `;

// const TableCell = styled.td`
//   padding: 1rem;
//   border-bottom: 1px solid #dee2e6;
// `;

// const AdminButton = styled.button`
//   background: #007bff;
//   color: white;
//   padding: 0.5rem 1rem;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   margin-bottom: 1rem;

//   &:hover {
//     background: #0056b3;
//   }
// `;

// const LoginContainer = styled.div`
//   max-width: 400px;
//   margin: 2rem auto;
//   padding: 2rem;
//   background: white;
//   border-radius: 15px;
//   box-shadow: 0 0px 16px rgba(0, 0, 0, 0.2);
// `;

// const LoginTitle = styled.h2`
//   font-size: 2rem;
//   margin-bottom: 2rem;
//   color: #333;
//   text-align: center;
// `;

// const LoginForm = styled.form`
//   display: flex;
//   flex-direction: column;
//   gap: 1rem;
// `;

// const LoginInput = styled.input`
//   padding: 0.75rem;
//   border: 1px solid #ddd;
//   border-radius: 5px;
//   font-size: 1rem;
//   transition: border-color 0.3s ease;

//   &:focus {
//     outline: none;
//     border-color: #007bff;
//   }
// `;

// const LoginButton = styled.button`
//   background: #007bff;
//   color: white;
//   padding: 0.75rem;
//   border: none;
//   border-radius: 5px;
//   font-size: 1rem;
//   cursor: pointer;
//   transition: background 0.3s ease;

//   &:hover {
//     background: #0056b3;
//   }
// `;

// const ErrorMessage = styled.div`
//   color: #dc3545;
//   margin-top: 1rem;
//   text-align: center;
// `;

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    description: ''
  });
  const [contacts, setContacts] = useState([]);
  // const [showAdmin, setShowAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  const carouselImages = [bg1, bg2, bg3];

  const [teamMembers, setTeamMembers] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const projectsRef = ref(database, 'projects');
    const unsubscribe = onValue(projectsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const projectArray = Object.entries(data).map(([id, item]) => ({
          id,
          title: item.title,
          description: item.description,
          tech: item.technologies || [],
          link: item.link,
          image: item.imageUrl
        }));
        setProjects(projectArray);
      }
    });

    return () => unsubscribe();
  }, []);


  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const dbRef = ref(database);
        const snapshot = await get(child(dbRef, "teamMembers"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          const members = Object.values(data).map(member => ({
            name: member.name,
            role: member.role,
            bio: member.description,
            github: member.github,
            linkedin: member.linkedin,
            email: member.email,
            photo: member.imageUrl, // or load local fallback if needed
            skills: member.skills || [],
          }));
          setTeamMembers(members);
        } else {
          console.log("No team members found");
        }
      } catch (error) {
        console.error("Error fetching team members:", error);
      }
    };

    fetchTeamMembers();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
        setIsTransitioning(false);
      }, 1000);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
      setIsTransitioning(false);
    }, 1000);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
      setIsTransitioning(false);
    }, 1000);
  };

  const goToSlide = (index) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 1000);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const teamLeader = {
    name: "Susovan Das",
    role: "Team Leader",
    bio: "Experienced full-stack developer with expertise in mobile, web, hardware and database technologies. ",
    github: "https://github.com/Susovan292",
    linkedin: "https://linkedin.com/in/susovan-das-66503a298",
    email: "susovandas805@gmail.com",
    photo: susovanDasProfilePhoto,
  }

  const getRoleIcon = (role) => {
    switch (role.toLowerCase()) {
      case 'team leader':
        return <FaCode />;
      case 'mobile development':
        return <FaMobile />;
      case 'design & marketing':
        return <FaPaintBrush />;
      case 'database and backend api':
        return <FaDatabase />;
      case 'devops and web':
        return <FaServer />;
      default:
        return <FaCode />;
    }
  };

  const achievements = [
    {
      icon: <FaTrophy />,
      title: "Hackathon Winners",
      description: "Won multiple hackathons with innovative solutions in mobile and database technologies."
    },
    {
      icon: <FaUsers />,
      title: "Active Community",
      description: "Building a strong developer community with active recruitments and events."
    },
    {
      icon: <FaCodeBranch />,
      title: "Open Source",
      description: "Contributed to numerous open-source projects and maintained popular repositories."
    }
  ];


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const contactsRef = ref(database, 'messages');
      const newContactRef = push(contactsRef);
      await set(newContactRef, {
        ...formData,
        createdAt: new Date().toISOString()
      });

      setFormData({
        name: '',
        phone: '',
        email: '',
        description: ''
      });
      alert('Form submitted successfully!');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form. Please try again.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const userCredential = await signInWithEmailAndPassword(
  //       auth,
  //       loginData.email,
  //       loginData.password
  //     );
  //     setIsAuthenticated(true);
  //     setLoginError('');
  //   } catch (error) {
  //     console.error('Error logging in:', error);
  //     setLoginError('Invalid credentials');
  //   }
  // };

  // const handleLogout = async () => {
  //   try {
  //     await signOut(auth);
  //     setIsAuthenticated(false);
  //   } catch (error) {
  //     console.error('Error logging out:', error);
  //   }
  // };

  useEffect(() => {
    if (isAuthenticated) {
      const contactsRef = ref(database, 'contacts');
      onValue(contactsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const contactsList = Object.entries(data).map(([id, contact]) => ({
            id,
            ...contact
          }));
          setContacts(contactsList);
        }
      });
    }
  }, [isAuthenticated]);

  return (
    <Router>
      <AppContainer>
        <style>
          {`
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Poppins:wght@400;500;600;700&display=swap');
          `}
        </style>
        <Routes>
          <Route path="/" element={
            <>
              <Navbar>
                <NavLeft>
                  <LogoImage src={logo} alt="CodeNexUX Logo" />
                  <Logo>CodeNexUX</Logo>
                </NavLeft>
                <NavRight>
                  <MobileMenuButton onClick={toggleMenu}>
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                  </MobileMenuButton>
                  <NavLinks isOpen={isMenuOpen}>
                    <NavLink href="#about" onClick={() => setIsMenuOpen(false)}>About</NavLink>
                    <NavLink href="#achievements" onClick={() => setIsMenuOpen(false)}>Achievements</NavLink>
                    <NavLink href="#projects" onClick={() => setIsMenuOpen(false)}>Projects</NavLink>
                    <NavLink href="#team" onClick={() => setIsMenuOpen(false)}>Team</NavLink>
                    <NavLink href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</NavLink>
                  </NavLinks>
                </NavRight>
              </Navbar>

              <HeroSection>
                {carouselImages.map((image, index) => (
                  <HeroBackground
                    key={index}
                    style={{ backgroundImage: `url(${image})` }}
                    className={index === currentSlide ? 'active' : ''}
                  />
                ))}
                <HeroContent>
                  <HeroTitle>CodeNexUX</HeroTitle>
                  <HeroSubtitle>A Community for Devlopment and Hackathons</HeroSubtitle>
                
                  <Button href="/join">Become a Member</Button>
                  <HeroButtonContainer>
                    <ExtraButton href="https://www.linkedin.com/company/team-codenexus/">Follow on LinkedIn</ExtraButton>
                    <ExtraButton href="https://discord.gg/aPKJ8BGv">Join Our Discord</ExtraButton>
                  </HeroButtonContainer>

                  
                </HeroContent>
                <CarouselControls>
                  <CarouselButton onClick={prevSlide}>
                    <FaChevronLeft />
                  </CarouselButton>
                  <CarouselButton onClick={nextSlide}>
                    <FaChevronRight />
                  </CarouselButton>
                </CarouselControls>
                <CarouselIndicators>
                  {carouselImages.map((_, index) => (
                    <Indicator
                      key={index}
                      active={index === currentSlide}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </CarouselIndicators>
              </HeroSection>

              <Section id="about">
                <SectionTitle>About CodeNexUX</SectionTitle>
                <p style={{ textAlign: 'center', maxWidth: '800px', margin: '50px auto', lineHeight: '1.6', fontSize: '1.5rem', fontStyle: 'italic' }}>
                  CodeNexUX is a dynamic team of developers specializing in mobile application development and database solutions.
                  We combine cutting-edge technology with innovative thinking to create seamless user experiences and robust data management systems.
                  Our team consists of 5 talented individuals, each bringing unique expertise to the table.
                </p>
              </Section>


              <AchievementsSection id="achievements">
                <SectionTitle>Our Achievements</SectionTitle>
                <AchievementsGrid>
                  {achievements.map((achievement, index) => (
                    <AchievementCard key={index}>
                      <AchievementIcon>{achievement.icon}</AchievementIcon>
                      <AchievementTitle>{achievement.title}</AchievementTitle>
                      <AchievementDescription>{achievement.description}</AchievementDescription>
                    </AchievementCard>
                  ))}
                </AchievementsGrid>
              </AchievementsSection>

              <Section id="projects">
                <SectionTitle>Our Projects</SectionTitle>
                <ProjectsGrid>
                  {projects.map((project, index) => (
                    <ProjectCard key={index}>
                      {/* <ProjectImage>
                        <FaProjectDiagram />
                      </ProjectImage> */}
                      <ProjectImage style={{ backgroundImage: `url(${project.image})` }} />
                      <ProjectContent>
                        <ProjectTitle>{project.title}</ProjectTitle>
                        <ProjectDescription>{project.description}</ProjectDescription>
                        <ProjectTech>
                          {project.tech.map((tech, techIndex) => (
                            <TechTag key={techIndex}>{tech}</TechTag>
                          ))}
                        </ProjectTech>
                        <ProjectLink href={project.link}>
                          View Project <FaCode />
                        </ProjectLink>
                      </ProjectContent>
                    </ProjectCard>
                  ))}
                </ProjectsGrid>
              </Section>



              <TeamSection id="team">
                <SectionTitle>Our Team</SectionTitle>


                <TeamGrid>
                  <LeaderCard>
                    <ProfilePhoto>
                      <img src={teamLeader.photo} alt={teamLeader.name} />
                    </ProfilePhoto>
                    <div className="leader-details">
                      <TeamName>{teamLeader.name}</TeamName>
                      <TeamRole>
                        <TeamIcon>
                          {getRoleIcon(teamLeader.role)}
                        </TeamIcon>
                        {teamLeader.role}
                      </TeamRole>
                      <TeamBio>{teamLeader.bio}</TeamBio>
                      <TeamSocialLinks>
                        <TeamSocialLink href={teamLeader.github} target="_blank" rel="noopener noreferrer">
                          <FaGithub />
                        </TeamSocialLink>
                        <TeamSocialLink href={teamLeader.linkedin} target="_blank" rel="noopener noreferrer">
                          <FaLinkedin />
                        </TeamSocialLink>
                        <TeamSocialLink href={`mailto:${teamLeader.email}`}>
                          <FaEnvelope />
                        </TeamSocialLink>
                      </TeamSocialLinks>
                    </div>
                  </LeaderCard>


                  {teamMembers.map((member, index) => (

                  <TeamCard key={index} isLeader={member.isLeader}>
                    <ProfilePhoto>
                      <img src={member.photo} alt={member.name} />
                    </ProfilePhoto>
                    <TeamName>{member.name}</TeamName>
                    <TeamRole>
                      <TeamIcon>
                        {getRoleIcon(member.role)}
                      </TeamIcon>
                      {member.role}
                    </TeamRole>
                    <TeamBio>{member.bio}</TeamBio>
                    <TeamSocialLinks>
                      <TeamSocialLink href={member.github} target="_blank" rel="noopener noreferrer">
                        <FaGithub />
                      </TeamSocialLink>
                      <TeamSocialLink href={member.linkedin} target="_blank" rel="noopener noreferrer">
                        <FaLinkedin />
                      </TeamSocialLink>
                      <TeamSocialLink href={`mailto:${member.email}`}>
                        <FaEnvelope />
                      </TeamSocialLink>
                    </TeamSocialLinks>
                  </TeamCard>
                  ))}
                  
                </TeamGrid>
              </TeamSection>

              <Section id="contact">
                <SectionTitle>Send a Message</SectionTitle>
                <ContactForm onSubmit={handleSubmit}>
                  <FormGroup>
                    <FormLabel htmlFor="name">Name</FormLabel>
                    <FormInput
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormLabel htmlFor="phone">Phone Number</FormLabel>
                    <FormInput
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormLabel htmlFor="email">Email</FormLabel>
                    <FormInput
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <FormLabel htmlFor="description">Your Message</FormLabel>
                    <FormTextarea
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </FormGroup>
                  <SubmitButton type="submit">Submit</SubmitButton>
                </ContactForm>
              </Section>
            </>
          } />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/team" element={
            <ProtectedRoute>
              <TeamMembers />
            </ProtectedRoute>
          } />
          <Route path="/admin/achievements" element={
            <ProtectedRoute>
              <Achievements />
            </ProtectedRoute>
          } />
          <Route path="/admin/projects" element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          } />
          <Route path="/join" element={<NewMemberPage />} />
        </Routes>
      </AppContainer>
    </Router>
  );
}

export default App;

